import React, { useState } from 'react'
import { AddProductButton, Card, Separator } from './style'
import ProductSection from './OrderSections/Product';
import DetailsSection from './OrderSections/Details';
import MainInfosSection from './OrderSections/MainInfos';

interface OrderType {
  supplier: any
  seller: any
  customer: any
  orderType: any
  orderDate: any
  deadline: any
  paymentCondition: any
  typeOfFreight: any
  valueOfFreight: any
  trackingCode: any
  attached: any
  moreObservations: any
}

interface ProductType {
  product: any
  ncm: any
  format: any
  diameter: any
  thickness: any
  length: any
  finishing: any
  weigth: any
  specs: any
  quantity: any
}

interface DeadlineType {
  internal: any
  external: any
}

interface PricesType {
  minPricePerKg: any
  finalPricePerKg: any
  unitPrice: any
  discount: any
  totalValue: any
}

const CreateOrder = () => {
  const [ order, setOrder ] = useState({

  })
  
  return(
    <>
      <Card>
        <MainInfosSection />
        <Separator />
        <DetailsSection />
      </Card>
      <Card>
        <ProductSection />
      </Card>
      <AddProductButton>+ Adicionar produto</AddProductButton>
    </>
  )
}

export default CreateOrder